import customerNotAssociated from './customer_not_associated.component';

let customerNotAssociatedModule = angular.module('customernotassociated', [
])

  .component('customernotassociated', customerNotAssociated)

  .name;

export default customerNotAssociatedModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/customer_not_associated/index.js